import { type BannersList } from '@cx-web/api-clients/banners-api/types';
import { trackEvent } from '@cx-web/utils/dataLayer';

import styles from './BannersCarousel.module.css';
import { getWebPImageUrlWithWidth } from './getWebPImageUrlWithWidth';
import { events } from './types';

// Mobile/tablet horizontal-scroll grid. Pure presentational: `isMobile` (picks the small-image width)
// arrives as a prop from the parent BannersCarousel — RR7 read it from useMedia, atlas-astro from
// useDevice; neither distinction reaches here. See ./BannersCarousel.
function BannersCarouselGrid({ banners, isMobile }: { banners: BannersList; isMobile: boolean }) {
  const imageWidth = isMobile ? 320 : 800;

  return (
    <ul className={styles.gridContainer}>
      {banners.map((banner, idx) => (
        <li className={styles.gridItem} key={idx}>
          <a
            href={banner.ctaUrl}
            onClick={() => {
              trackEvent(events.SPLASH_BANNER_CLICK, {
                eventAction: events.SPLASH_BANNER_CLICK,
                label: banner.style,
                bannerName: banner.bannerName,
                bannerType: banner.bannerType,
                bookieCode: banner.bookieCode,
                url: banner.ctaUrl,
                position: idx,
              });
            }}
            rel="noreferrer"
            target="_blank"
          >
            <div aria-label={banner.imageSmall.alt} className={styles.slide}>
              <img
                alt={banner.imageSmall.alt}
                className={styles.bannerImg}
                draggable={false}
                fetchPriority={idx === 0 ? 'high' : 'low'}
                src={getWebPImageUrlWithWidth(banner.imageSmall.url, imageWidth)}
              />
            </div>
          </a>
        </li>
      ))}
    </ul>
  );
}

export default BannersCarouselGrid;
